import TextFieldBaseSkeleton, { Props as TextFieldBaseSkeletonProps } from '../TextFieldBase/Skeleton';

interface Props extends TextFieldBaseSkeletonProps {}

const TextFieldSkeleton = (props: Props) => {
  return <TextFieldBaseSkeleton {...props} />;
};

export default TextFieldSkeleton;
